import { useSearchParams } from "react-router-dom";

/**
 * Wiederverwendbare Filter-Pill-Gruppe (Runde 121).
 *
 * Props:
 * - options: [[key, label, color], ...]
 * - value: aktueller Filter-Key
 * - onChange(key)
 * - testidPrefix: default "filter-"
 * - showDot: default true (kleiner Farbpunkt vor Label)
 *
 * Styling matcht das verbesserte Filter-Pill-Design aus dem Produktions-
 * Monitor (Runde 120): 2px Border in Pink bei Aktiv, Shadow, Scale-Effekt.
 */
export default function FilterPills({ options, value, onChange, testidPrefix = "filter-", showDot = true }) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {options.map(([k, l, c]) => {
        const active = value === k;
        const dot = c || "#e5e5e5";
        return (
          <button key={k}
                  onClick={() => onChange(k)}
                  data-testid={`${testidPrefix}${k}`}
                  className={`px-4 py-2 rounded-full font-bold text-xs inline-flex items-center gap-1.5 transition-all border-2 ${
                    active
                      ? "border-[var(--pop-pink)] shadow-md scale-105"
                      : "text-[var(--text-muted)] bg-[var(--surface-alt)] border-[var(--border)] hover:text-[var(--text)] hover:border-[var(--pop-pink)]"
                  }`}
                  style={active ? { background: c, color: "#171717" } : undefined}>
            {showDot && (
              <span className="inline-block w-2 h-2 rounded-full"
                    style={{ background: (dot === "#e5e5e5" && k !== "planned") ? "#171717" : dot }} />
            )}
            {l}
          </button>
        );
      })}
    </div>
  );
}

/**
 * Hook zum Persistieren eines Filter-Wertes in der URL-Query.
 * Beispiel: const [status, setStatus] = useQueryFilter("status", "all");
 */
export function useQueryFilter(paramName, defaultValue = "all") {
  const [sp, setSp] = useSearchParams();
  const current = sp.get(paramName) || defaultValue;
  const set = (v) => {
    const next = new URLSearchParams(sp);
    if (!v || v === defaultValue) next.delete(paramName);
    else next.set(paramName, v);
    setSp(next, { replace: true });
  };
  return [current, set];
}
